import React, { useState, useEffect } from 'react';
import jwt_decode from 'jwt-decode';
import { Alert } from '@mui/material';

const Timer = () => {
    const [timeLeft, setTimeLeft] = useState(0);    
    const token = sessionStorage.getItem('token')

    useEffect(() => {
        // Si no hay token, no hay sesión activa
        if (!token) {
            setTimeLeft(0);
            return;
        }

        // Decodifica el token JWT
        const decodedToken = jwt_decode(token);

        // Obtiene la fecha de expiración (exp) y la convierte a milisegundos
        const expTime = decodedToken.exp * 1000; // exp está en segundos, lo convertimos a milisegundos

        // Función que actualiza el tiempo restante
        const updateTimeLeft = () => {
            const currentTime = new Date().getTime();
            const remainingTime = expTime - currentTime;

            // Si el tiempo restante es menor o igual a 0, la sesión ha expirado
            if (remainingTime <= 0) {
                setTimeLeft(0);
                sessionStorage.clear();
                window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/logout`)
            } else {
                setTimeLeft(remainingTime);
            }
        };

        // Actualiza el tiempo cada segundo
        const intervalId = setInterval(updateTimeLeft, 1000);

        // Llama la función inmediatamente para establecer el valor inicial
        updateTimeLeft();

        // Limpia el intervalo cuando el componente se desmonta
        return () => clearInterval(intervalId);
    }, [token]);

    // Convierte el tiempo restante a formato de horas, minutos y segundos
    const formatTime = (timeInMs) => {
        const hours = Math.floor(timeInMs / 1000 / 60 / 60); // Calcula las horas
        const minutes = Math.floor((timeInMs / 1000 / 60) % 60); // Calcula los minutos
        const seconds = Math.floor((timeInMs / 1000) % 60); // Calcula los segundos
        
        return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    return (
            <Alert severity={timeLeft <= 300000 && token ? 'error' : 'info'} style={{width: '300px'}}>
                {timeLeft > 0 ? (
                    `Tiempo restante de sesión: ${formatTime(timeLeft)}`
                ) : (
                    token ? `La sesión ha expirado`:''
                )}
            </Alert>            
    );
};

export default Timer;